import 'bootstrap/scss/bootstrap.scss'
import 'bootstrap-colorpicker/dist/css/bootstrap-colorpicker.css'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'select2/dist/css/select2.css'
import 'pretty-checkbox/dist/pretty-checkbox.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-pro/scss/fontawesome.scss'
import '@fortawesome/fontawesome-pro/scss/light.scss'
import '@fortawesome/fontawesome-pro/scss/regular.scss'
import '@fortawesome/fontawesome-pro/scss/solid.scss'
import './../scss/forms.scss'
import './../scss/datagrid.scss'
import './../scss/documentsgrid.scss'
import './../scss/imagegrid.scss'
import './../scss/logbook.scss'
import './../scss/recording.scss'
import './../scss/sample.scss'
import './../scss/session.scss'
import './../scss/smart-upload.scss'
import './../scss/style.scss'
import './../scss/tooltip.scss'
import './../scss/stepper.scss'
import './../scss/badge.scss'
import './../scss/button.scss'
import './../scss/fullcalendar.scss'
import 'lightgallery/scss/lightgallery.scss'
import './../scss/email-modal.scss'
import './jquery'
import './nette'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap'
import 'moment'
import 'bootstrap-colorpicker/dist/js/bootstrap-colorpicker'
import 'eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker'
import 'react-datepicker/dist/react-datepicker.min.css'
import 'jquery-contextmenu/dist/jquery.contextMenu.css'
import 'select2/dist/js/select2'
import { createSkillsPicker } from './components/Ticket/createSkillsPicker'
import { loadServiceAppointmentModal } from './components/ServiceAppointment/createServiceAppointmentModal'
import createConfirm from './modal/createConfirm'
import { deleteServiceAppointment } from './services/api/serviceAppointment'
import { createLoader, removeLoader } from './loader'
import createModal from './modal/createModal'
import { goToServiceAppointmentLogbook } from './services/utils/redirect'
import { _ } from './gettext'
import { loadTrumbowyg } from './trumbowyg'
import showdown from 'showdown'

$(document).ready(function () {
  $.nette.init()

  const $body = $('body')

  $body.tooltip({
    selector: '[data-toggle="tooltip"]'
  })

  $body.on('click', '.datetime-control + .input-group-append', function () {
    $('input', $(this).parent()).focus()
  })

  function attachMenuEvents () {
    const $navIconMenu = $('.nav-icons-menu')
    const $navMenu = $('.nav-menu')

    // relates to cases when jQuery DOM-ready event gets fired before React component gets mounted
    // @to-do -> make this part of the main-menu component to reduce dependency on jQuery
    if ($navIconMenu.length && $navMenu.length) {
      $navIconMenu.on('click', function () {
        $navMenu.slideToggle()
      })
    } else {
      setTimeout(() => { attachMenuEvents() }, 1000)
    }
  }

  attachMenuEvents()

  $body.on('click', '.btn-session-picker', function (e) {
    e.preventDefault()
    goToServiceAppointmentLogbook($(this).attr('data-id'))
  })

  $body.on('click', '.btn-skills-picker', function (e) {
    e.preventDefault()
    createSkillsPicker()
  })

  $body.on('click', '.btn-load-service-appointment', function (e) {
    e.preventDefault()
    loadServiceAppointmentModal($(this).attr('data-id'))
  })
})

function deleteReservation (reservationId, calendar) {
  createConfirm(
    _('Opravdu chcete rezervaci vymazat?'),
    () => {
      createLoader()
      deleteServiceAppointment(reservationId).then(({ data }) => {
        if (data.messages?.length > 0) {
          removeLoader()
          createModal(_('Upozornění'), data.messages.join('<br />')).show()
        } else {
          removeLoader()
          calendar.refetchResources()
          calendar.refetchEvents()
        }
      })
    }
  ).show()
}

window.deleteReservation = deleteReservation
window.loadTrumbowyg = loadTrumbowyg
window.translateMarkdown = function (markdown) {
  const showdownConverter = new showdown.Converter({ simpleLineBreaks: true })

  return showdownConverter.makeHtml(markdown)
}
